import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/vantui'
import 'reset-css'
import GM from './utils/common.js'
Vue.config.productionTip = false
Vue.prototype.$GM = GM
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
